import heroBgSvg from "../../../assets/image/hero bg.svg?raw";

const HeroBackground = ({ isStatic = false }) => (
  <div
    className={`pointer-events-none absolute inset-x-0 top-[50px] z-0 w-full select-none opacity-100 [&_svg]:h-auto [&_svg]:w-full ${
      isStatic ? "hero-bg-static" : ""
    }`}
    aria-hidden="true"
    dangerouslySetInnerHTML={{ __html: heroBgSvg }}
  />
);

export default HeroBackground;
